<template>
    <TopNav></TopNav>
		<h1>Ülkeler Arası Saat Farkı Hesaplama</h1>
		<fieldset>
      <legend>Ülkeler Arası Saat Farkı Hesaplama</legend>
      <label for="firstTimeZone">Birinci Zaman Dilimi:</label><br>
      <select name="firstTimeZone" id="firstTimeZone" v-model="firstTimeZone">
        <option value="America/Chicago">Amerika/Chicago</option>
        <option value="America/Denver">Amerika/Denver</option>
        <option value="America/Los_Angeles">Amerika/Los_Angeles</option>
        <option value="America/New_York">Amerika/New_York</option>
        <option value="America/Toronto">Amerika/Toronto</option>
        <option value="Asia/Shanghai">Asya/Şangay</option>
        <option value="Asia/Tokyo">Asya/Tokyo</option>
        <option value="Asia/Ulaanbaatar">Asya/Ulan_Batur</option>
        <option value="Europe/Amsterdam">Avrupa/Amsterdam</option>
        <option value="Europe/Athens">Avrupa/Atina</option>
        <option value="Europe/Belgrade">Avrupa/Belgrat</option>
        <option value="Europe/Berlin">Avrupa/Berlin</option>
        <option value="Europe/Brussels">Avrupa/Brüksel</option>
        <option value="Europe/Bucharest">Avrupa/Bükreş</option>
        <option value="Europe/Istanbul">Avrupa/İstanbul</option>
        <option value="Europe/Kiev">Avrupa/Kiev</option>
        <option value="Europe/London">Avrupa/Londra</option>
        <option value="Europe/Luxembourg">Avrupa/Lüksemburg</option>
        <option value="Europe/Moscow">Avrupa/Moskova</option>
        <option value="Europe/Paris">Avrupa/Paris</option>
        <option value="Europe/Rome">Avrupa/Roma</option>
        <option value="Europe/Sofia">Avrupa/Sofya</option>
        <option value="Europe/Warsaw">Avrupa/Varşova</option>
        <option value="Europe/Vienna">Avrupa/Viyana</option>
        <option value="Europe/Zurich">Avrupa/Zürih</option>
        <option value="Pacific/Auckland">Pacifik/Auckland</option>
      </select>

      <span class="clock">{{ firstTime }}</span>

      <br><br>

      <label for="secondTimeZone">İkinci Zaman Dilimi:</label><br>
      <select name="secondTimeZone" id="secondTimeZone" v-model="secondTimeZone">
        <option value="America/Chicago">Amerika/Chicago</option>
        <option value="America/Denver">Amerika/Denver</option>
        <option value="America/Los_Angeles">Amerika/Los_Angeles</option>
        <option value="America/New_York">Amerika/New_York</option>
        <option value="America/Toronto">Amerika/Toronto</option>
        <option value="Asia/Shanghai">Asya/Şangay</option>
        <option value="Asia/Tokyo">Asya/Tokyo</option>
        <option value="Asia/Ulaanbaatar">Asya/Ulan_Batur</option>
        <option value="Europe/Amsterdam">Avrupa/Amsterdam</option>
        <option value="Europe/Athens">Avrupa/Atina</option>
        <option value="Europe/Belgrade">Avrupa/Belgrat</option>
        <option value="Europe/Berlin">Avrupa/Berlin</option>
        <option value="Europe/Brussels">Avrupa/Brüksel</option>
        <option value="Europe/Bucharest">Avrupa/Bükreş</option>
        <option value="Europe/Istanbul">Avrupa/İstanbul</option>
        <option value="Europe/Kiev">Avrupa/Kiev</option>
        <option value="Europe/London">Avrupa/Londra</option>
        <option value="Europe/Luxembourg">Avrupa/Lüksemburg</option>
        <option value="Europe/Moscow">Avrupa/Moskova</option>
        <option value="Europe/Paris">Avrupa/Paris</option>
        <option value="Europe/Rome">Avrupa/Roma</option>
        <option value="Europe/Sofia">Avrupa/Sofya</option>
        <option value="Europe/Warsaw">Avrupa/Varşova</option>
        <option value="Europe/Vienna">Avrupa/Viyana</option>
        <option value="Europe/Zurich">Avrupa/Zürih</option>
        <option value="Pacific/Auckland">Pacifik/Auckland</option>
      </select>

      <span class="clock">{{ secondTime }}</span>

      <br><br>
      Fark: <span class="result">{{ hoursDiff() }} saat</span>
		</fieldset>
</template>

<script>
import TopNav from './components/TopNav.vue'
import {DateTime, Duration} from "luxon";

export default {
  name: 'UlkelerArasiSaatFarki',
  data() {
    return {
      firstTimeZone: "Europe/Istanbul",
      secondTimeZone: "Europe/Berlin",
      firstTime: "00:00",
      secondTime: "00:00"
    }
  },
  components: {
    TopNav
  },
  methods: {
    hoursDiff: function () {
      let d1 = DateTime.local().setZone(this.firstTimeZone);
      let d1offset = d1.offset;
      this.firstTime = d1.toFormat("T");

      let d2 = DateTime.local().setZone(this.secondTimeZone);
      let d2offset = d2.offset;
      this.secondTime = d2.toFormat("T");

      let diffMinutes = d1offset - d2offset;

      let absDiffMin = Math.abs(diffMinutes);
      let dur = Duration.fromObject({ minutes: absDiffMin })
      let hours = dur.as('hours');
      return hours;
    },
    getFirstTimeZoneHour: function () {
      this.firstTime = DateTime.local().setZone(this.firstTimeZone).toFormat("T");
    },
    getSecondTimeZoneHour: function () {
      this.secondTime = DateTime.local().setZone(this.secondTimeZone).toFormat("T");
    }
  },
  mounted: function () {
    setInterval(function () {
      this.getFirstTimeZoneHour();
      this.getSecondTimeZoneHour();
    }.bind(this), 10000)
  }
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

body {
  margin: 1em auto;
  margin-top: 0;
  max-width: 40em;
  font-family: Arial, Helvetica, sans-serif;
}

.result {
  color: #0063dc;
}

label {
  display: inline-block;
  min-width: 175px;
}

footer section a {
  margin: 20px;
}

.clock {
  margin-left: 10px;
}
</style>
